import React from "react";
import { NavLink } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link, Users } from "lucide-react";

/**
 * Affiliate URL Summary Widget
 * Modernized with shadcn components - Shows custom URLs and affiliate signups
 */
function Affiliate_Url_summary({ customurlno, signedupno }) {
    return (
        <Card>
            <CardHeader className="flex flex-row items-center justify-between">
                <CardTitle className="text-lg font-semibold text-primary flex items-center gap-2">
                    Affiliate URLs
                </CardTitle>
                <NavLink to="/ref">
                    <Button variant="ghost" size="sm" className="text-accent hover:text-accent hover:bg-sidebar-accent">
                        Affiliate URLs
                    </Button>
                </NavLink>
            </CardHeader>
            <CardContent>
                <div className="grid grid-cols-2 gap-4">
                    <div className="space-y-1">
                        <p className="text-sm font-medium text-primary/70 flex items-center gap-1">
                            <Link className="h-4 w-4" />
                            Custom URLs
                        </p>
                        <p className="text-2xl font-bold text-primary">{customurlno || 0}</p>
                    </div>
                    <div className="space-y-1">
                        <p className="text-sm font-medium text-primary/70 flex items-center gap-1">
                            <Users className="h-4 w-4" />
                            Affiliates Signed up
                        </p>
                        <p className="text-2xl font-bold text-primary">{signedupno || 0}</p>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}

export default Affiliate_Url_summary;
